import { useTranslation } from 'react-i18next'

import { FormFieldReadOnlyTextValue } from '../../../../Form'
import { FormikField } from '../../../../Formik'
import { TASK_FORM_CREATED_FIELD_NAME } from '../../TaskForm.constants'

function CreatedField() {
  const { t } = useTranslation()

  return (
    <FormikField
      Component={FormFieldReadOnlyTextValue}
      fieldComponentProps={{
        label: `${t('Task.FormCreatedFieldLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      name={TASK_FORM_CREATED_FIELD_NAME}
    />
  )
}

export default CreatedField
